module.exports = __webpack_public_path__ + "static/img/logo_pps.488e2ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login/logo_pps.png
// module id = 2947
// module chunks = 1